module.exports = __webpack_public_path__ + "static/img/banner_5.deec1d9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/carousel/banner_5.jpg
// module id = SYFf
// module chunks = 1